import React from 'react';
import { Dialog, DialogContent, DialogTitle } from '@material-ui/core';

import { PrintReceivedPalletAndCaseLabels } from './printReceivedPalletAndCaseTags';

function PrintReceivedPalletAndCaseLabelsModal({ onClose, open, poMapId, type }) {
    return (
        <div>
            <Dialog open={open} onClose={onClose} fullWidth maxWidth="lg">
                <DialogTitle style={{ textAlign: 'center', paddingBottom: 0 }}>
                    Print Pallet And Case Labels
                </DialogTitle>
                <DialogContent style={{ margin: 0 }}>
                    <PrintReceivedPalletAndCaseLabels type={type} poMapId={poMapId} />
                </DialogContent>
            </Dialog>
        </div>
    );
}

export { PrintReceivedPalletAndCaseLabelsModal };
